import { UpgradeSubscriptionModal } from '@components'

import { Flex, IconButton, Spacing, useModal } from '@billy/design-system'
import { type ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { InvoicingSettingsModal } from '@features/invoicingSettings/elements/InvoicingSettingsModal'
import { InvoicingSettingsEntryContext } from '@features/invoicingSettings/enums/invoicingSettingsEntryContext'
import { useIsInvoicingSettingsModalEnabled } from '@features/invoicingSettings/hooks/useIsInvoicingSettingsModalEnabled'

import { ModalId } from '../../../../../../enums/modalId'
import { TrackingContext } from '../../../../../../enums/trackingContext'
import { CreateDepositInvoiceButton } from '../../elements/CreateDepositInvoiceButton'
import { CreateDepositInvoiceEntryPointModal } from '../../elements/CreateDepositInvoiceEntryPointModal'
import { CreateInvoiceButton } from '../CreateInvoiceButton'

export const InvoicesListSideActions = (): ReactElement => {
  const { t } = useTranslation()
  const { open } = useModal(ModalId.InvoicingSettingsModal)
  const isInvoicingSettingsModalEnabled = useIsInvoicingSettingsModalEnabled()

  const handleInvoicingSettingsButtonClick = useCallback(() => {
    open()
  }, [open])

  return (
    <>
      <Flex gap={Spacing.S8}>
        {isInvoicingSettingsModalEnabled && (
          <IconButton
            aria-label={t('invoicing_settings.title')}
            icon="settings"
            onClick={handleInvoicingSettingsButtonClick}
            size="md"
            variant="outlined"
          />
        )}
        <CreateInvoiceButton />
        <CreateDepositInvoiceButton />
      </Flex>

      {isInvoicingSettingsModalEnabled && (
        <InvoicingSettingsModal
          entryContext={InvoicingSettingsEntryContext.Invoice}
          id={ModalId.InvoicingSettingsModal}
        />
      )}
      <CreateDepositInvoiceEntryPointModal id={ModalId.CreateDepositInvoiceEntryPointModal} />
      <UpgradeSubscriptionModal
        id={ModalId.UpgradeSubscriptionModal}
        trackingContext={TrackingContext.DepositInvoiceUpsellInvoicesList}
      />
    </>
  )
}
